import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { db } from "@/firebase";
import { collection, query, where, getDocs } from 'firebase/firestore';

class StripeServices {

  async getUserDataByUID(uid) {
    const usersCollection = collection(db, 'users');
    const q = query(usersCollection, where("userId", "==", uid));
    const querySnapshot = await getDocs(q);

    let userData = null;
    querySnapshot.forEach((doc) => {
      userData = doc.data();
    });

    return userData;
  }

  async getAPIKey() {
    try {
      let apiKey;
      const auth = getAuth();
      const user = auth.currentUser;
      const userDoc = await this.getUserDataByUID(user.uid);
      if (userDoc && userDoc.apiKey) {
        apiKey = userDoc.apiKey;
      }
      return apiKey
    } catch (error) {
      console.error('Failed to fetch user API key from Firebase', error);
    }
  }

  async getDefaultPaymentMethod() {
    const key = await this.getAPIKey()
    const response = await axios.get(`https://www.slant3dapi.com/api/stripe/paymentMethod`,
      {
        headers: {
          "api-key": `${key}`,
          'Content-Type': 'application/json'
        }
      }
    )
    return response.data.data[0].info;
  }
  async updatePaymentMethod(paymentMethodId) {
    try {
      let key = await this.getAPIKey()
      const response = await axios.put('https://www.slant3dapi.com/api/stripe/update', {
        paymentMethodId: paymentMethodId
      },
        {
          headers: {
            "api-key": `${key}`,
            'Content-Type': 'application/json'
          }
        });
      return response
    } catch (error) {
      console.error(error)
    }
  }

  async createPaymentMethod(email, paymentMethodId) {
    const response = await axios.post('https://www.slant3dapi.com/api/stripe/create', {
      email: email,
      paymentMethodId: paymentMethodId
    });
    return response
  }

}

export const stripeServices = new StripeServices()